import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type TemplateFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const TemplateFilled = forwardRef<SVGSVGElement, TemplateFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-2.737683 -2.811334) scale(1.228128)">
        <path fillRule="evenodd" clipRule="evenodd" d="M19.6385 6.40532L16.0659 2.84948C15.8358 2.62089 15.5239 2.49256 15.1988 2.49268H7.56655C6.84959 2.49268 6.2705 3.06905 6.2705 3.78266V18.2835C6.2705 18.9941 6.84959 19.5735 7.56655 19.5735H18.704C19.4179 19.5735 20 18.9971 20 18.2835V7.26836C19.9976 6.94467 19.8678 6.63483 19.6385 6.40532ZM5.65156 4.49912V18.9578C5.65156 19.6703 6.22954 20.2514 6.94514 20.2514H17.7036V20.334C17.7036 21.0496 17.1225 21.6275 16.41 21.6275H5.29382C4.57822 21.6275 4.00024 21.0465 4.00024 20.334V5.7927C4.00024 5.0771 4.57822 4.49912 5.29382 4.49912H5.65156ZM17.3286 8.00011H9.67143C9.22381 8.00011 9 8.22392 9 8.67154V8.75725C9 9.20487 9.22381 9.42868 9.67143 9.42868H17.3286C17.7762 9.42868 18 9.20487 18 8.75725V8.67154C18 8.22392 17.7762 8.00011 17.3286 8.00011ZM17.3286 10.7287H9.67143C9.22381 10.7287 9 10.9525 9 11.4001V11.4858C9 11.9334 9.22381 12.1573 9.67143 12.1573H17.3286C17.7762 12.1573 18 11.9334 18 11.4858V11.4001C18 10.9525 17.7762 10.7287 17.3286 10.7287ZM9.67143 13.4573H14.3286C14.7762 13.4573 15 13.6811 15 14.1287V14.2144C15 14.662 14.7762 14.8858 14.3286 14.8858H9.67143C9.22381 14.8858 9 14.662 9 14.2144V14.1287C9 13.6811 9.22381 13.4573 9.67143 13.4573Z" />
      </g>
    </svg>
  ),
);

TemplateFilled.displayName = 'TemplateFilled';

export default TemplateFilled;
